@if (datesUI) {
  <swiper-container #swiper ushSwiperElement [config]="swiperConfig" init="false">
    @for (date of datesUI | keyvalue; track date; let i = $index) {
      <swiper-slide>
        <ng-container *ngIf="formatDateInLines(date?.value | titlecase, date?.key) as formattedDate">
          <a
            class="date-item {{ clickedItem === i ? 'active' : '' }}"
            (click)="dateClicked(i, date?.key)"
            (keyup)="dateKeyup($event, i, date?.key)"
            [attr.data-translate]="formattedDate.key"
            [innerHTML]="formattedDate.value | safe: 'html'"
            tabindex="0"
          >
          </a>
        </ng-container>
      </swiper-slide>
    }
  </swiper-container>
} @else {
  <p data-translate="dates-carousel.noDatesAvailable " i18n="@@dates-carousel.noDatesAvailable">
    {{ 'dates-carousel.noDatesAvailable' | rt: 'No dates available' }}
  </p>
}
